export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImJmODdmNGNjLWFlNDYtNDhhNy1hZGIzLWMyZWI2ZjMyNjgxZCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.gknoqz8+JDDvL5hr2pcnKzj/R6wjZ7A+NeMTrmKCXPg1Qxw/3xDz2DFPD0RbxfdhmksEpSP0FjdSwemAJIzp0vlKxbnAfhKfHpV9psDZjxFSbEmt3IAwJvQ4R46JecUpUNyT7w==";
